import { Organisation } from '@percent/domain/verifications'

export enum HostedFormStep {
  // Keep proper order to easier maintain and handle progress
  INTRODUCTION = 'INTRODUCTION',

  NOMINATOR_DETAILS = 'NOMINATOR_DETAILS',

  // Org related steps
  ORGANISATION_ORIGIN = 'ORGANISATION_ORIGIN',
  SELECT_ORGANISATION = 'SELECT_ORGANISATION',
  REGISTER_ORGANISATION = 'REGISTER_ORGANISATION',
  ORGANISATION_RESULT = 'ORGANISATION_RESULT',

  NOMINEES = 'NOMINEES',

  TERMS = 'TERMS',

  COMPLETE = 'COMPLETE',
}

export type Categories = {
  id: string
  name: string
  imageUrl: string
  createdAt: string
}

export type Milestone = {
  id: number
  amount: number
  reward: string
  currencyCode: string
  organisationId: string
}

export type GetOrganisationsConfiguration = {
  data: Organisation[]
  object: 'organisation'
  pageNumber: number
  pageSize: number
  totalResults: number
  nextPage: string
  _links: {
    current: string
    next: string
    prev: string
  }
}
